/*
 * Popups plugin
 */
(function ($) {
  function ContentPopup(opt) {
    this.options = $.extend({
      holder: null,
      popup: '.popup',
      btnOpen: '.open',
      btnClose: '.close',
      openClass: 'popup-active',
      clickEvent: 'click',
      mode: 'click',
      hideOnClickLink: true,
      hideOnClickOutside: true,
      delay: 50,
    }, opt);
    if (this.options.holder) {
      this.holder = $(this.options.holder);
      this.init();
    }
  }
  ContentPopup.prototype = {
    init() {
      this.findElements();
      this.attachEvents();
    },
    findElements() {
      this.popup = this.holder.find(this.options.popup);
      this.btnOpen = this.holder.find(this.options.btnOpen);
      this.btnClose = this.holder.find(this.options.btnClose);
    },
    attachEvents() {
      // handle popup openers
      const self = this;
      this.clickMode = isTouchDevice || (self.options.mode === self.options.clickEvent);

      if (this.clickMode) {
        // handle click mode
        this.btnOpen.bind(`${self.options.clickEvent}.popup`, (e) => {
          if (self.holder.hasClass(self.options.openClass)) {
            if (self.options.hideOnClickLink) {
              self.hidePopup();
            }
          } else {
            self.showPopup();
          }
          e.preventDefault();
        });

        // prepare outside click handler
        this.outsideClickHandler = this.bind(this.outsideClickHandler, this);
      } else {
        // handle hover mode
        let timer; const
          delayedFunc = function (func) {
            clearTimeout(timer);
            timer = setTimeout(() => {
              func.call(self);
            }, self.options.delay);
          };
        this.btnOpen.on('mouseover.popup', () => {
          delayedFunc(self.showPopup);
        }).on('mouseout.popup', () => {
          delayedFunc(self.hidePopup);
        });
        this.popup.on('mouseover.popup', () => {
          delayedFunc(self.showPopup);
        }).on('mouseout.popup', () => {
          delayedFunc(self.hidePopup);
        });
      }

      // handle close buttons
      this.btnClose.on(`${self.options.clickEvent}.popup`, (e) => {
        self.hidePopup();
        e.preventDefault();
      });
    },
    outsideClickHandler(e) {
      // hide popup if clicked outside
      const targetNode = $((e.changedTouches ? e.changedTouches[0] : e).target);
      if (!targetNode.closest(this.popup).length && !targetNode.closest(this.btnOpen).length) {
        this.hidePopup();
      }
    },
    showPopup() {
      // reveal popup
      this.holder.addClass(this.options.openClass);
      this.popup.css({
        display: 'block',
      });
      initCustomForms();

      // outside click handler
      if (this.clickMode && this.options.hideOnClickOutside && !this.outsideHandlerActive) {
        this.outsideHandlerActive = true;
        $(document).on('click touchstart', this.outsideClickHandler);
      }
    },
    hidePopup() {
      // hide popup
      this.holder.removeClass(this.options.openClass);
      this.popup.css({
        display: 'none',
      });

      // outside click handler
      if (this.clickMode && this.options.hideOnClickOutside && this.outsideHandlerActive) {
        this.outsideHandlerActive = false;
        $(document).off('click touchstart', this.outsideClickHandler);
      }
    },
    bind(f, scope, forceArgs) {
      return function () {
        return f.apply(scope, forceArgs ? [forceArgs] : arguments);
      };
    },
    destroy() {
      this.popup.removeAttr('style');
      this.holder.removeClass(this.options.openClass);
      this.btnOpen.add(this.btnClose).add(this.popup).off('.popup');
      $(document).off('click touchstart', this.outsideClickHandler);
    },
  };

  // detect touch devices
  var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

  // jQuery plugin interface
  $.fn.contentPopup = function (opt) {
    const args = Array.prototype.slice.call(arguments);
    const method = args[0];

    return this.each(function () {
      const $holder = jQuery(this);
      const instance = $holder.data('ContentPopup');

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        $holder.data('ContentPopup', new ContentPopup($.extend({
          holder: this,
        }, opt)));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };
}(jQuery));
